import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleCardsSection() {
  return (
    <section id="artykuly" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 text-xs font-medium rounded-full mb-4">
            Artykuły SEO
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Przewodniki i poradniki USFansSpreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Poznaj nasze artykuły – od rankingów przez poradniki bezpieczeństwa po analizy cen. Wszystko, co musisz wiedzieć o USFansSpreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group flex flex-col bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-700 rounded-full">
                    {article.readTime}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1 line-clamp-3">
                  {article.description}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-100">
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full bg-accent-200 flex items-center justify-center">
                      <i className="ri-user-line text-accent-700 text-xs"></i>
                    </div>
                    <span className="text-xs text-foreground-500">{article.author}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}